(ns frontend.view.grid.surveys-grid.columns)

;;default set of selected columns
(def ordered-default-columns
  [:survey-profile/type
   :survey-profile/target
   :survey-profile/last-process-status
   :survey-profile/last-process-invitees
   :survey-profile/our-contact
   :survey-profile/their-contact])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{})
